/* Performance Reel mobile ordering — uses the existing four header elements.
 * Draggable section blocks control order. No cloned cart, search, or menu.
 * Desktop nodes and order are restored on viewport change.
 */
(function () {
  'use strict';
  if (window.__prmMobileHeaderOrderReady) return;
  window.__prmMobileHeaderOrderReady = true;

  var markers = new Map();
  var changed = [];
  var scheduled = false;
  var editorVisuals = new Map();
  function inThemeEditor() {
    return !!(window.Shopify && window.Shopify.designMode);
  }

  function part(section) { return document.querySelector('[id$="__' + section + '"]'); }

  function restore() {
    markers.forEach(function (marker, element) {
      if (marker.parentNode && element.isConnected) {
        marker.parentNode.insertBefore(element, marker);
      }
      if (marker.parentNode) marker.parentNode.removeChild(marker);
      if (element && element.hasAttribute('data-prm-editor-announcement')) {
        element.style.removeProperty('display');
        element.removeAttribute('aria-hidden');
        element.removeAttribute('data-prm-editor-announcement');
      }
    });
    markers.clear();
    editorVisuals.clear();
    changed.forEach(function (element) {
      if (element) element.style.removeProperty('order');
    });
    changed = [];
    document.documentElement.removeAttribute('data-prm-mobile-order-active');
  }

  function setOrder(element, value) {
    if (!element) return;
    element.style.setProperty('order', String(value), 'important');
    changed.push(element);
  }

  function apply() {
    scheduled = false;
    var config = document.querySelector('[data-prm-mobile-order]');
    var mobile = window.matchMedia('(max-width:1024px)').matches;
    if (!config || config.getAttribute('data-enabled') !== 'true' || !mobile) {
      restore();
      return;
    }

    var header = document.querySelector('header.headertype2');
    if (!header) return;
    var topbar = Array.from(header.children).find(function (el) {
      return el.classList && el.classList.contains('pr-search-topbar');
    });
    var brand = Array.from(header.children).find(function (el) {
      return el.classList && el.classList.contains('tt-mobile-header');
    });
    var search = topbar && Array.from(topbar.children).find(function (el) {
      return el.classList && el.classList.contains('pr-topbar-search');
    });
    var utility = topbar && Array.from(topbar.children).find(function (el) {
      return el.classList && (el.classList.contains('container') || el.classList.contains('container-fluid'));
    });
    var announcementOriginal = part('pr_announcement_original');
    var announcementWhite = part('pr_announcement_white');
    var announcements = [announcementOriginal, announcementWhite].filter(Boolean);

    // Do not activate partial layouts; the existing Wokiee header stays intact.
    if (!topbar || !brand || !search || !utility || !announcements.length) {
      restore();
      return;
    }

    var order = Array.from(config.querySelectorAll('[data-prm-part]'))
      .map(function (el) { return el.getAttribute('data-prm-part'); })
      .filter(function (x) { return ['announcement','search','utility','identity'].indexOf(x) !== -1; });
    ['announcement','search','utility','identity'].forEach(function (key) {
      if (order.indexOf(key) === -1) order.push(key);
    });

    // Preserve the original appearance of the charcoal topbar after exposing
    // its two child rows as independent flex items.
    if (!document.documentElement.hasAttribute('data-prm-mobile-order-active')) {
      var bg = window.getComputedStyle(topbar).backgroundColor;
      if (!bg || bg === 'rgba(0, 0, 0, 0)' || bg === 'transparent') bg = '#171b20';
      header.style.setProperty('--prm-order-topbar-background', bg);
    }
    var editor = inThemeEditor();
    var visualAnnouncements = [];
    announcements.forEach(function (wrapper) {
      // Leave Shopify's section wrappers in place in the Theme Editor.
      // Moving the wrapper into the header can produce a broken-HTML warning
      // when Shopify replaces or reorders one of the editor's native sections.
      var el = wrapper;
      if (editor) {
        el = editorVisuals.get(wrapper) ||
          wrapper.querySelector(':scope > section.pr-promo, :scope > section.pr-promo2');
        if (!el) return;
        editorVisuals.set(wrapper, el);
        el.setAttribute('data-prm-editor-announcement',
          wrapper === announcementOriginal ? 'original' : 'white');
      }
      if (!markers.has(el) || !markers.get(el).isConnected) {
        if (!el.parentNode) return;
        var marker = document.createComment('PR announcement original position');
        el.parentNode.insertBefore(marker, el);
        markers.set(el, marker);
      }
      if (el.parentNode !== header) header.insertBefore(el, header.firstChild);
      visualAnnouncements.push(el);
    });

    // In the editor the inner promo element is moved, not its parent Shopify
    // wrapper. The original global visibility selectors target the wrapper,
    // so reproduce their active-bar choice on the editor's visual element.
    if (editor) {
      var chosen = (config.getAttribute('data-prm-mobile-announcement') || '2').toLowerCase();
      var originals = visualAnnouncements.find(function (el) {
        return el.getAttribute('data-prm-editor-announcement') === 'original';
      });
      var whites = visualAnnouncements.find(function (el) {
        return el.getAttribute('data-prm-editor-announcement') === 'white';
      });
      var active = chosen === 'off' ? null :
        chosen === '1' ? (originals || whites) : (whites || originals);
      visualAnnouncements.forEach(function (el) {
        if (el === active) {
          el.style.removeProperty('display');
          el.setAttribute('aria-hidden', 'false');
        } else {
          el.style.setProperty('display', 'none', 'important');
          el.setAttribute('aria-hidden', 'true');
        }
      });
    }

    changed.forEach(function (el) { if (el) el.style.removeProperty('order'); });
    changed = [];
    setOrder(search, order.indexOf('search') + 1);
    setOrder(utility, order.indexOf('utility') + 1);
    setOrder(brand, order.indexOf('identity') + 1);
    visualAnnouncements.forEach(function (el) {
      setOrder(el, order.indexOf('announcement') + 1);
    });
    document.documentElement.setAttribute('data-prm-mobile-order-active', 'true');
  }

  function requestApply() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(apply);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', requestApply);
  } else requestApply();
  window.addEventListener('resize', requestApply);
  window.addEventListener('pageshow', requestApply);
  document.addEventListener('shopify:section:unload', function (event) {
    // Before Shopify replaces a section, return its visual content to the
    // native wrapper so the Theme Editor can safely re-render that section.
    var target = event.target;
    if (!target || !target.id) return;
    if (target.id.indexOf('pr_announcement_') !== -1 ||
        target.id.indexOf('pr_mobile_header_order') !== -1 ||
        target.id.indexOf('header-template-2') !== -1) {
      restore();
    }
  });
  document.addEventListener('shopify:section:load', requestApply);
  document.addEventListener('shopify:section:reorder', requestApply);
  document.addEventListener('shopify:block:select', requestApply);
  document.addEventListener('shopify:block:deselect', requestApply);
})();